import Icon from '@/components/ui/AppIcon';

interface Category {
  id: number;
  name: string;
  icon: string;
  count: string;
  color: string;
}

interface CategoryShowcaseProps {
  categories: Category[];
}

export default function CategoryShowcase({ categories }: CategoryShowcaseProps) {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-text-primary mb-4">
            Explore Stories by Genre
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            From heart-warming romance to spine-chilling thrillers, find your perfect audio companion
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((category) => (
            <button
              key={category.id}
              className="group relative bg-card rounded-2xl p-6 md:p-8 shadow-warm hover:shadow-warm-lg transition-all duration-300 hover:-translate-y-2 overflow-hidden"
            >
              <div className={`absolute inset-0 ${category.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} />
              
              <div className="relative space-y-4">
                <div className={`w-16 h-16 ${category.color} rounded-2xl flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300`}>
                  <Icon name={category.icon as any} size={32} className="text-white" />
                </div>
                
                <div className="text-center">
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-1">
                    {category.name}
                  </h3>
                  <p className="text-sm text-text-secondary">{category.count} stories</p>
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/stories-library"
            className="inline-flex items-center space-x-2 text-primary font-semibold hover:text-primary-dark transition-colors"
          >
            <span>View All Categories</span>
            <Icon name="ArrowRightIcon" size={20} />
          </a>
        </div>
      </div>
    </section>
  );
}